export * from './IInfo';
export * from './IStore';
export * from './IPlatform';
export * from './IWebSocket';
export * from './requests';
export * from './browser/BrowserRequests';

import BrowserWebSocket from './browser/BrowserWebSocket';

export {
  BrowserWebSocket
};